'use client';
import * as React from 'react';
import { ThemeContext } from '../Theme/index.js';
import { Link as Link$1 } from 'react-router-dom';

var ButtonType;
(function (ButtonType) {
    ButtonType["SUBMIT"] = "submit";
    ButtonType["RESET"] = "reset";
    ButtonType["BUTTON"] = "button";
})(ButtonType || (ButtonType = {}));
var ButtonVariant;
(function (ButtonVariant) {
    ButtonVariant["PRIMARY"] = "primary";
    ButtonVariant["SECONDARY"] = "secondary";
    ButtonVariant["INFO"] = "info";
    ButtonVariant["SUCCESS"] = "success";
    ButtonVariant["DANGER"] = "danger";
    ButtonVariant["WARNING"] = "warning";
})(ButtonVariant || (ButtonVariant = {}));
var ButtonSize;
(function (ButtonSize) {
    ButtonSize["XXLARGE"] = "2xl";
    ButtonSize["XLARGE"] = "xl";
    ButtonSize["LARGE"] = "lg";
    ButtonSize["MEDIUM"] = "md";
    ButtonSize["SMALL"] = "sm";
})(ButtonSize || (ButtonSize = {}));
var ButtonTheme;
(function (ButtonTheme) {
    ButtonTheme["ALLIEDCONTAINER"] = "acem";
    ButtonTheme["ALLIEDCONTAINER2"] = "acem2";
    ButtonTheme["ALLIEDFOOD"] = "afood";
    ButtonTheme["ALLIEDDEPOT"] = "acds";
    ButtonTheme["WINSPEC"] = "winspec";
    ButtonTheme["AGLOGIS"] = "aglogis";
    ButtonTheme["ACSMARINE"] = "acsm";
})(ButtonTheme || (ButtonTheme = {}));
var themes = new Map();
var acemTheme = new Map();
acemTheme.set("", "inline-block rounded-full ease-out duration-500 disabled:bg-gray-300 disabled:border-0 disabled:text-gray-800 font-bold");
acemTheme.set("variant-".concat(ButtonVariant.PRIMARY), "bg-acem-red text-acem-white");
acemTheme.set("variant-".concat(ButtonVariant.SECONDARY), "bg-white text-acem-black border-1 border-acem-black");
acemTheme.set("variant-".concat(ButtonVariant.INFO), "bg-blue-500 hover:bg-blue-400 text-white");
acemTheme.set("variant-".concat(ButtonVariant.SUCCESS), "bg-green-600 hover:bg-green-500 text-white");
acemTheme.set("variant-".concat(ButtonVariant.DANGER), "bg-red-600 hover:bg-red-400 text-white");
acemTheme.set("variant-".concat(ButtonVariant.WARNING), "bg-amber-600 hover:bg-amber-700 text-white");
acemTheme.set("size-".concat(ButtonSize.XXLARGE), "xs:py-4 sm:py-4 md:py-4 lg:py-6 xs:px-3 sm:px-6 md:px-7 lg:px-8 text-base md:text-xl");
acemTheme.set("size-".concat(ButtonSize.XLARGE), "xs:py-3.5 sm:py-3.5 md:py-3.5 lg:py-4 xs:px-3 sm:px-4 md:px-5 lg:px-6 text-base md:text-lg");
acemTheme.set("size-".concat(ButtonSize.LARGE), "py-2.5 px-4");
acemTheme.set("size-".concat(ButtonSize.MEDIUM), "py-2 px-3");
acemTheme.set("size-".concat(ButtonSize.SMALL), "py-1 px-2 text-sm");
acemTheme.set("disabled-true", "cursor-not-allowed");
acemTheme.set("disabled-false", "cursor-pointer");
var acem2Theme = new Map();
acem2Theme.set("", "inline-block rounded-md ease-out duration-500 disabled:bg-gray-300 disabled:border-0 disabled:text-gray-800 font-satoshi font-medium");
acem2Theme.set("variant-".concat(ButtonVariant.PRIMARY), "bg-acem2-primary hover:bg-acem2-maroon text-white");
acem2Theme.set("variant-".concat(ButtonVariant.SECONDARY), "bg-acem2-white hover:bg-acem2-cloud text-acem2-black border-1 border-acem2-black");
acem2Theme.set("variant-".concat(ButtonVariant.INFO), "bg-blue-500 hover:bg-blue-400 text-white");
acem2Theme.set("variant-".concat(ButtonVariant.SUCCESS), "bg-green-600 hover:bg-green-500 text-white");
acem2Theme.set("variant-".concat(ButtonVariant.DANGER), "bg-red-600 hover:bg-red-400 text-white");
acem2Theme.set("variant-".concat(ButtonVariant.WARNING), "bg-amber-600 hover:bg-amber-700 text-white");
acem2Theme.set("size-".concat(ButtonSize.XXLARGE), "xs:py-4 sm:py-4 md:py-4 lg:py-6 xs:px-3 sm:px-6 md:px-7 lg:px-8 text-base md:text-xl");
acem2Theme.set("size-".concat(ButtonSize.XLARGE), "xs:py-3.5 sm:py-3.5 md:py-3.5 lg:py-4 xs:px-3 sm:px-4 md:px-5 lg:px-6 text-base md:text-lg");
acem2Theme.set("size-".concat(ButtonSize.LARGE), "py-2.5 px-4");
acem2Theme.set("size-".concat(ButtonSize.MEDIUM), "py-2 px-3");
acem2Theme.set("size-".concat(ButtonSize.SMALL), "py-1 px-2 text-sm");
acem2Theme.set("disabled-true", "cursor-not-allowed");
acem2Theme.set("disabled-false", "cursor-pointer");
var afoodTheme = new Map();
afoodTheme.set("", "inline-block rounded-md ease-out duration-500 disabled:bg-gray-300 disabled:border-0 disabled:text-gray-800 font-poppins");
afoodTheme.set("variant-".concat(ButtonVariant.PRIMARY), "bg-afood-primary border-1 border-transparent hover:bg-white hover:border-afood-primary text-black");
afoodTheme.set("variant-".concat(ButtonVariant.SECONDARY), "bg-afood-secondary border-1 border-transparent hover:bg-white hover:border-afood-secondary text-black");
afoodTheme.set("variant-".concat(ButtonVariant.INFO), "bg-blue-500 hover:bg-blue-400 text-white");
afoodTheme.set("variant-".concat(ButtonVariant.SUCCESS), "bg-green-600 hover:bg-green-500 text-white");
afoodTheme.set("variant-".concat(ButtonVariant.DANGER), "bg-red-600 hover:bg-red-400 text-white");
afoodTheme.set("variant-".concat(ButtonVariant.WARNING), "bg-amber-600 hover:bg-amber-700 text-white");
afoodTheme.set("size-".concat(ButtonSize.XXLARGE), "xs:py-4 sm:py-4 md:py-4 lg:py-6 xs:px-3 sm:px-6 md:px-7 lg:px-8 text-base md:text-xl");
afoodTheme.set("size-".concat(ButtonSize.XLARGE), "xs:py-3.5 sm:py-3.5 md:py-3.5 lg:py-4 xs:px-3 sm:px-4 md:px-5 lg:px-6 text-base md:text-lg");
afoodTheme.set("size-".concat(ButtonSize.LARGE), "py-2.5 px-4");
afoodTheme.set("size-".concat(ButtonSize.MEDIUM), "py-2 px-3");
afoodTheme.set("size-".concat(ButtonSize.SMALL), "py-1 px-2 text-sm");
afoodTheme.set("disabled-true", "cursor-not-allowed");
afoodTheme.set("disabled-false", "cursor-pointer");
var winspecTheme = new Map();
winspecTheme.set("", "inline-block rounded-full ease-out duration-500 disabled:bg-gray-300 disabled:border-0 disabled:text-gray-800 font-bold");
winspecTheme.set("variant-".concat(ButtonVariant.PRIMARY), "bg-winspec-primary border-1 border-transparent hover:bg-white text-white hover:text-winspec-primary hover:border-winspec-primary");
winspecTheme.set("variant-".concat(ButtonVariant.SECONDARY), "bg-white border-1 border-black text-black");
winspecTheme.set("variant-".concat(ButtonVariant.INFO), "bg-blue-500 hover:bg-blue-400 text-white");
winspecTheme.set("variant-".concat(ButtonVariant.SUCCESS), "bg-green-600 hover:bg-green-500 text-white");
winspecTheme.set("variant-".concat(ButtonVariant.DANGER), "bg-red-600 hover:bg-red-400 text-white");
winspecTheme.set("variant-".concat(ButtonVariant.WARNING), "bg-amber-600 hover:bg-amber-700 text-white");
winspecTheme.set("size-".concat(ButtonSize.XXLARGE), "xs:py-4 sm:py-4 md:py-4 lg:py-6 xs:px-3 sm:px-6 md:px-7 lg:px-8 text-base md:text-xl");
winspecTheme.set("size-".concat(ButtonSize.XLARGE), "xs:py-3.5 sm:py-3.5 md:py-3.5 lg:py-4 xs:px-3 sm:px-4 md:px-5 lg:px-6 text-base md:text-lg");
winspecTheme.set("size-".concat(ButtonSize.LARGE), "py-2 px-6");
winspecTheme.set("size-".concat(ButtonSize.MEDIUM), "py-2 px-3");
winspecTheme.set("size-".concat(ButtonSize.SMALL), "py-1 px-2 text-sm");
winspecTheme.set("disabled-true", "cursor-not-allowed");
winspecTheme.set("disabled-false", "cursor-pointer");
var aglogisTheme = new Map();
aglogisTheme.set("", "inline-block rounded-2xl ease-out duration-500 disabled:bg-gray-300 disabled:border-0 disabled:text-gray-800 font-open-sans");
aglogisTheme.set("variant-".concat(ButtonVariant.PRIMARY), "bg-aglogis-primary text-white");
aglogisTheme.set("variant-".concat(ButtonVariant.SECONDARY), "bg-white text-black border-1 border-aglogis-primary");
aglogisTheme.set("variant-".concat(ButtonVariant.INFO), "bg-blue-500 hover:bg-blue-400 text-white");
aglogisTheme.set("variant-".concat(ButtonVariant.SUCCESS), "bg-green-600 hover:bg-green-500 text-white");
aglogisTheme.set("variant-".concat(ButtonVariant.DANGER), "bg-red-600 hover:bg-red-400 text-white");
aglogisTheme.set("variant-".concat(ButtonVariant.WARNING), "bg-amber-600 hover:bg-amber-700 text-white");
aglogisTheme.set("size-".concat(ButtonSize.XXLARGE), "xs:py-4 sm:py-4 md:py-4 lg:py-6 xs:px-3 sm:px-6 md:px-7 lg:px-8 text-base md:text-xl");
aglogisTheme.set("size-".concat(ButtonSize.XLARGE), "xs:py-3.5 sm:py-3.5 md:py-3.5 lg:py-4 xs:px-3 sm:px-4 md:px-5 lg:px-6 text-base md:text-lg");
aglogisTheme.set("size-".concat(ButtonSize.LARGE), "py-2.5 px-4");
aglogisTheme.set("size-".concat(ButtonSize.MEDIUM), "py-2 px-3");
aglogisTheme.set("size-".concat(ButtonSize.SMALL), "py-1 px-2 text-sm");
aglogisTheme.set("disabled-true", "cursor-not-allowed");
aglogisTheme.set("disabled-false", "cursor-pointer");
var acdsTheme = new Map();
acdsTheme.set("", "inline-block rounded-full ease-out duration-500 disabled:bg-gray-300 disabled:border-0 disabled:text-gray-800 font-bold");
acdsTheme.set("variant-".concat(ButtonVariant.PRIMARY), "bg-acds-primary text-white hover:bg-white hover:text-acds-primary border-1 border-transparent hover:border-acds-primary");
acdsTheme.set("variant-".concat(ButtonVariant.SECONDARY), "bg-white text-black border-1 border-black hover:bg-acds-primary hover:text-white hover:border-acds-primary");
acdsTheme.set("variant-".concat(ButtonVariant.INFO), "bg-blue-500 hover:bg-blue-400 text-white");
acdsTheme.set("variant-".concat(ButtonVariant.SUCCESS), "bg-green-600 hover:bg-green-500 text-white");
acdsTheme.set("variant-".concat(ButtonVariant.DANGER), "bg-red-600 hover:bg-red-400 text-white");
acdsTheme.set("variant-".concat(ButtonVariant.WARNING), "bg-amber-600 hover:bg-amber-700 text-white");
acdsTheme.set("size-".concat(ButtonSize.XXLARGE), "xs:py-4 sm:py-4 md:py-4 lg:py-6 xs:px-3 sm:px-6 md:px-7 lg:px-8 text-base md:text-xl");
acdsTheme.set("size-".concat(ButtonSize.XLARGE), "xs:py-3.5 sm:py-3.5 md:py-3.5 lg:py-4 xs:px-3 sm:px-4 md:px-5 lg:px-6 text-base md:text-lg");
acdsTheme.set("size-".concat(ButtonSize.LARGE), "py-2.5 px-4");
acdsTheme.set("size-".concat(ButtonSize.MEDIUM), "py-2 px-3");
acdsTheme.set("size-".concat(ButtonSize.SMALL), "py-1 px-2 text-sm");
acdsTheme.set("disabled-true", "cursor-not-allowed");
acdsTheme.set("disabled-false", "cursor-pointer");
var acsmTheme = new Map();
acsmTheme.set("", "inline-block rounded-full ease-out duration-500 disabled:bg-gray-300 disabled:border-0 disabled:text-gray-800 font-verdana sm:!font-poppins");
acsmTheme.set("variant-".concat(ButtonVariant.PRIMARY), "bg-acsm-primary text-black border-1 border-transparent hover:border-black");
acsmTheme.set("variant-".concat(ButtonVariant.SECONDARY), "bg-white text-black border-1 border-transparent hover:border-black");
acsmTheme.set("variant-".concat(ButtonVariant.INFO), "bg-blue-500 hover:bg-blue-400 text-white");
acsmTheme.set("variant-".concat(ButtonVariant.SUCCESS), "bg-green-600 hover:bg-green-500 text-white");
acsmTheme.set("variant-".concat(ButtonVariant.DANGER), "bg-red-600 hover:bg-red-400 text-white");
acsmTheme.set("variant-".concat(ButtonVariant.WARNING), "bg-amber-600 hover:bg-amber-700 text-white");
acsmTheme.set("size-".concat(ButtonSize.XXLARGE), "xs:py-4 sm:py-4 md:py-4 lg:py-6 xs:px-4 sm:px-6 md:px-8 lg:px-10 text-base md:text-xl");
acsmTheme.set("size-".concat(ButtonSize.XLARGE), "xs:py-3.5 sm:py-3.5 md:py-3.5 lg:py-4 xs:px-4 sm:px-5 md:px-6 lg:px-9 text-base md:text-lg");
acsmTheme.set("size-".concat(ButtonSize.LARGE), "py-3 px-8");
acsmTheme.set("size-".concat(ButtonSize.MEDIUM), "py-2 px-7");
acsmTheme.set("size-".concat(ButtonSize.SMALL), "py-1 px-3 text-sm");
acsmTheme.set("disabled-true", "cursor-not-allowed");
acsmTheme.set("disabled-false", "cursor-pointer");
themes.set(ButtonTheme.ALLIEDCONTAINER, acemTheme);
themes.set(ButtonTheme.ALLIEDCONTAINER2, acem2Theme);
themes.set(ButtonTheme.ALLIEDFOOD, afoodTheme);
themes.set(ButtonTheme.ALLIEDDEPOT, acdsTheme);
themes.set(ButtonTheme.WINSPEC, winspecTheme);
themes.set(ButtonTheme.AGLOGIS, aglogisTheme);
themes.set(ButtonTheme.ACSMARINE, acsmTheme);
var ButtonStyle = /** @class */ (function () {
    function ButtonStyle() {
        this.theme = "";
        this.variant = "";
        this.size = "";
        this.disabled = false;
        this.appendedClassNames = "";
    }
    ButtonStyle.prototype.build = function () {
        var style = "";
        var theme = themes.get(this.theme);
        if (!theme) {
            return style;
        }
        if (theme.has("")) {
            style += theme.get("");
        }
        if (theme.has("variant-".concat(this.variant))) {
            style += " " + theme.get("variant-".concat(this.variant));
        }
        if (theme.has("size-".concat(this.size))) {
            style += " " + theme.get("size-".concat(this.size));
        }
        if (theme.has("disabled-".concat(this.disabled))) {
            style += " " + theme.get("disabled-".concat(this.disabled));
        }
        if (this.appendedClassNames !== "") {
            style += " " + this.appendedClassNames;
        }
        return style;
    };
    ButtonStyle.prototype.setTheme = function (theme) {
        this.theme = theme;
        return this;
    };
    ButtonStyle.prototype.setVariant = function (variant) {
        this.variant = variant;
        return this;
    };
    ButtonStyle.prototype.setSize = function (size) {
        this.size = size;
        return this;
    };
    ButtonStyle.prototype.setDisabled = function (disabled) {
        this.disabled = disabled || false;
        return this;
    };
    ButtonStyle.prototype.appendClassNames = function (classNames) {
        this.appendedClassNames = classNames || "";
        return this;
    };
    return ButtonStyle;
}());

var styleBuilder$1 = new ButtonStyle();
function Button(props) {
    var themeCtx = React.useContext(ThemeContext);
    var _a = props.theme, theme = _a === void 0 ? themeCtx.theme || ButtonTheme.ALLIEDCONTAINER : _a, _b = props.variant, variant = _b === void 0 ? ButtonVariant.PRIMARY : _b, _c = props.size, size = _c === void 0 ? ButtonSize.MEDIUM : _c, _d = props.type, type = _d === void 0 ? ButtonType.BUTTON : _d;
    var handleClick = function () {
        props.onClick && props.onClick();
    };
    var styleClassNames = styleBuilder$1.
        setTheme(theme).
        setVariant(variant).
        setSize(size).
        setDisabled(props.disabled).
        appendClassNames(props.appendClassNames).
        build();
    return (React.createElement("button", { type: type, onClick: handleClick, className: styleClassNames, disabled: props.disabled, style: props.style }, props.children));
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var Link = React.forwardRef(function (props, ref) {
    var _a = props.hideCrawl, hideCrawl = _a === void 0 ? false : _a;
    var isReactSnap = navigator && navigator.userAgent === "ReactSnap";
    props["hideCrawl"]; var linkProps = __rest(props, ['hideCrawl']);
    var linkComponent = React.createElement(Link$1, __assign({}, linkProps, { ref: ref }), props.children);
    if (!hideCrawl) {
        return linkComponent;
    }
    return React.createElement(React.Fragment, null, !isReactSnap && linkComponent);
});

var styleBuilder = new ButtonStyle();
var ButtonLink = React.forwardRef(function (props, ref) {
    var themeCtx = React.useContext(ThemeContext);
    var _a = props.theme, theme = _a === void 0 ? themeCtx.theme || ButtonTheme.ALLIEDCONTAINER : _a, _b = props.variant, variant = _b === void 0 ? ButtonVariant.PRIMARY : _b, _c = props.size, size = _c === void 0 ? ButtonSize.MEDIUM : _c;
    var handleClick = function () {
        props.onClick && props.onClick();
    };
    var styleClassNames = styleBuilder.
        setTheme(theme).
        setVariant(variant).
        setSize(size).
        appendClassNames(props.appendClassNames).
        build();
    return (React.createElement(Link, { ref: ref, to: props.to, target: props.target, hideCrawl: props.hideCrawl, className: styleClassNames, style: __assign({ textDecoration: "none" }, props.style), onClick: handleClick }, props.children));
});

export { Button, ButtonLink, ButtonSize, ButtonTheme, ButtonType, ButtonVariant };
